import axios from "axios";
import { useState } from "react";
import { useNavigate } from "react-router-dom";
import Select from "react-select"
import { API_CONFIG, API_HEADERS } from "../../network/config/ApiConfig";
import { AUDIO_ROOM_API_PATH } from "../../network/config/apiPaths";
function AddAlbumRoom() {
    const navigate = useNavigate();
    const [inputValidation, setInputValidation] = useState({
        name: "",
        url: "",
        date: "",
        max_participants:"",
        max_audiance:"",
        description:"",
    })
    const [patnerList, setPatnerList] = useState([
        { id: 1, name: "Chinni" },
        { id: 2, name: "Rajesh" },
        { id: 3, name: "Sravya" }
    ]);
    const handleChange = (e) => {
        setInputValidation({
            ...inputValidation,
            [e.target.name]: e.target.value
        })
    }

    const onSubmit = async () => {
        let requestbody = {
            title: inputValidation.name,
            description: inputValidation.description,
            max_participants: inputValidation.max_participants,
            max_audiance: inputValidation.max_audiance,
            url:inputValidation.url,
            duration:inputValidation.date
        }
        let data = await axios.post(API_CONFIG.API_HOST + AUDIO_ROOM_API_PATH.AUDIO_ROOM_UPDATE,requestbody, {
            headers: API_HEADERS
        })
        console.log("result",data.status);
        data.status===200&& navigate(-1)
    }

    return (
        <>
            <div
                style={{
                    position: "fixed",
                    backgroundColor: "rgba(0,0,0,0.5)",
                    width: "100%",
                    height: "100%",
                    zIndex: "999",
                    overflow: "scroll",
                }}
            >
                <div className="d-flex align-item-center justify-content-center">
                    <div className="col-md-8">
                        <div className="container">
                            <div className="row mt-2">
                                <div className="col-md-5 card-1 p-5">
                                    <h4 className="text-center">Add Audio Room</h4>
                                    <div className="col-md-12">
                                        <div className="form-group">
                                            {/* <label style={labelStyle}>Search City/Town</label>{" "} */}
                                            {/* {inputValidation.place_address} */}
                                            {/* <AutoComplete
                                                    className="form-control"
                                                    style={{ width: "100%" }}
                                                    name="city"
                                                    options={{
                                                        types: ["geocode", "establishment"],
                                                    }}
                                                    onChange={(e) => handleChange(e)}
                                                    value={inputvalidation.city}
                                                    apiKey={"AIzaSyCB14naEHjDiVBFLEqhPBMUA9eqg_4yRdk"}
                                                    onPlaceSelected={(place) => updatePlaceInfo(place)}
                                                    placeholder="Enter city name"
                                                />
     */}
                                            <label>Name</label>
                                            <input
                                                type="text"
                                                onChange={handleChange}
                                                name="name"
                                                value={inputValidation.name}
                                                className="form-control"

                                            />


                                            <label>url</label>
                                            <input
                                                type="text"
                                                onChange={handleChange}
                                                name="url"
                                                value={inputValidation.url}
                                                className="form-control"

                                            />
                                            <label>Date</label>
                                            <input
                                                type="date"
                                                onChange={handleChange}
                                                name="date"
                                                value={inputValidation.date}
                                                className="form-control"

                                            />
                                             <label>Maximum Participents</label>
                                            <input
                                                type="number"
                                                onChange={handleChange}
                                                name="max_participants"
                                                value={inputValidation.max_participants}
                                                className="form-control"

                                            />
                                             <label>Maximum Audiance</label>
                                            <input
                                                type="number"
                                                onChange={handleChange}
                                                name="max_audiance"
                                                value={inputValidation.max_audiance}
                                                className="form-control"

                                            />
                                             <label>Description</label>
                                            <input
                                                type="text"
                                                onChange={handleChange}
                                                name="description"
                                                value={inputValidation.description}
                                                className="form-control"

                                            />
                                            {/* <lable>Patners</lable>
                                               <Select
                                                
                                                name="selectedTags"
                                                isMulti
                                                options={patnerList}

                                                getOptionLabel={(option) => `${option.name}`}
                                                getOptionValue={(option) => `${option.id}`}
                                                // onChange={(sOptions) => {
                                                //     let tagsId = []

                                                //     sOptions.map(item => tagsId.push(item.id))

                                                //     setSelectedTags(sOptions);
                                                //     setSelectedTagIds(tagsId)
                                                // }}

                                            /> */}

                                            {/* {
                                                    item.role_id === "7" ? <>
                                                        <label>Franchise owner</label>
                                                        {
                                                            SelectFranchiseOwner()
                                                        }
                                                    </> : ""
                                                } */}

                                            {/* {item.role_id === "9" ? <>
                                                    <label>Franchise Percentage</label>
                                                    <input
                                                        type="number"
                                                        onChange={handleChange}
                                                        name="foShare"
                                                        value={inputvalidation.foShare}
    
                                                        className="form-control"
    
                                                    />
                                                </> : ""} */}

                                            {/* {
                                                    item.role_id === "9" ?
                                                        <>
                                                            <label>Radius</label>
                                                            <input
                                                                type="number"
                                                                onChange={handleChange}
                                                                name="radius"
                                                                value={inputvalidation.radius}
    
    
                                                                className="form-control"
    
                                                            />
                                                        </> : ""
                                                } */}
                                            {/* <label>Adhar Number</label>
                                                <input
                                                    type="number"
                                                    onChange={handleChange}
                                                    name="adhar"
                                                    value={inputvalidation.adhar}
                                                    className="form-control"
    
                                                />
                                                <label>PAN Number</label>
                                                <input
                                                    type="number"
                                                    onChange={handleChange}
                                                    name="pan"
                                                    value={inputvalidation.pan}
                                                    className="form-control"
    
                                                />
    
                                                <label>Driving License</label>
                                                <input
                                                    type="number"
                                                    onChange={handleChange}
                                                    name="license"
                                                    value={inputvalidation.license}
                                                    className="form-control"
    
                                                /> */}

                                            <div
                                                style={{
                                                    display: "flex",
                                                    justifyContent: "center",
                                                    marginTop: 20,
                                                }}
                                            >
                                                <button
                                                    style={{ display: "flex", justifyContent: "center" }}
                                                    type="button"
                                                    className="btn btn-purple-bg"
                                                onClick={onSubmit}
                                                >
                                                    Submit
                                                </button>

                                                <button
                                                    className="btn btn-white-bg"
                                                    onClick={() => {
                                                        // dispatch(
                                                        //   updateFormInfo({
                                                        //     displayForm: false,
                                                        //     formData: {},
                                                        //   })
                                                        // );
                                                        navigate(-1)
                                                    }}
                                                >
                                                    Cancel
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

        </>
    );


}
export default AddAlbumRoom